export const liveModeConstants = {
    RESET_LIVE_MODE: "RESET_LIVE_MODE",
    IS_LIVE_MODE_CHANGE: "IS_LIVE_MODE_CHANGE",
    IS_TYPING: "IS_TYPING",
    TYPING_USER: "TYPING_USER",
    LIVE_PARTICIPANTS: "LIVE_PARTICIPANTS",
    LIVE_TUTORS: "LIVE_TUTORS",
    ADD_PARTICIPANT: "ADD_PARTICIPANT",
    REMOVE_PARTICIPANT: "REMOVE_PARTICIPANT",
    REMOVE_TUTOR: "REMOVE_TUTOR",
    CLEAR_MEMBERS: "CLEAR_MEMBERS",
    IN_CALL_USERS: "IN_CALL_USERS",
    ADD_IN_CALL_USER: "ADD_IN_CALL_USER",
    REMOVE_IN_CALL_USERS: "REMOVE_IN_CALL_USERS",
    PHONE_RINGING: "PHONE_RINGING",
    RESET_PHONE_RINGING: "RESET_PHONE_RINGING",
    ADD_PHONE_RINGING: "ADD_PHONE_RINGING",
    REMOVE_PHONE_RINGING: "REMOVE_PHONE_RINGING",
    RAISED_HANDS: "RAISED_HANDS",
    ADD_RAISED_HAND: "ADD_RAISED_HAND",
    REMOVE_RAISED_HAND: "REMOVE_RAISED_HAND",
    SET_CALL_PORTAL: "SET_CALL_PORTAL",
    SHOW_INCOMING_CALL: "SHOW_INCOMING_CALL",
    HIDE_INCOMING_CALL: "HIDE_INCOMING_CALL",
    SET_MESSAGES: "SET_MESSAGES",
    NEW_LIVE_SESSION_LOG: "NEW_LIVE_SESSION_LOG",
    SET_TIMES_SINCE_LAST_CALL: "SET_TIMES_SINCE_LAST_CALL",
    PLAY_SOUND: "PLAY_SOUND",
    ACTIVITY_FINALIZED: "ACTIVITY_FINALIZED",
    SOUND_MODE: "SOUND_MODE",
    OUT_OF_APP: "OUT_OF_APP",
    PRECALL_DEVICES: "PRECALL_DEVICES",
    ACTIVITY_CAMERA_ON: "ACTIVITY_CAMERA_ON",
    VOICE_RECORDING_ACTIVITY: "VOICE_RECORDING_ACTIVITY",
    SET_ACTIVE_TIME: "SET_ACTIVE_TIME",
    SET_CALL_KEEP_UUID: "SET_CALL_KEEP_UUID",
    SET_CALLKEEP_ON: "SET_CALLKEEP_ON",
    SET_HAS_PHONE_PERMISSION: "SET_HAS_PHONE_PERMISSION",
    SET_CALL_STATE: "SET_CALL_STATE",
    TRIGGER_LK_EVENT: "TRIGGER_LK_EVENT",
    SET_POOR_CONNECTION_IDS: "SET_POOR_CONNECTION_IDS",
    ADD_POOR_CONNECTION_ID: "ADD_POOR_CONNECTION_ID",
    REMOVE_POOR_CONNECTION_ID: "REMOVE_POOR_CONNECTION_ID",
    SET_IS_LOCAL_POOR_CONNECTION: "SET_IS_LOCAL_POOR_CONNECTION",
    SET_NEW_TODO_ACTIVITY: "SET_NEW_TODO_ACTIVITY",
    SET_CURRENT_STUDENT_ACTIVITY: "SET_CURRENT_STUDENT_ACTIVITY",
    SET_SEEN_STUDENT_ACTIVITY: "SET_SEEN_STUDENT_ACTIVITY",
    REQUEST_STUDENT_ACTIVITY_FOCUS: "REQUEST_STUDENT_ACTIVITY_FOCUS",
    SET_IS_GRAYED_OUT: "SET_IS_GRAYED_OUT",

    UPDATE_AGENT_STATE: "UPDATE_AGENT_STATE",
    UPDATE_CONVERSATION: "UPDATE_CONVERSATION",
    SET_LAST_POPUP_TIME: "SET_LAST_POPUP_TIME",
    SET_SHOW_RAISE_HAND_CHECKPOINT: "SET_SHOW_RAISE_HAND_CHECKPOINT",
    SET_IS_AGENT_MODAL_VISIBLE: "SET_IS_AGENT_MODAL_VISIBLE",
    SET_MINI_MODE: "SET_MINI_MODE",
    SET_FOCUSED_MODE: "SET_FOCUSED_MODE",
    SET_SUGGESTED_ACTIVITY: "SET_SUGGESTED_ACTIVITY",
    UPDATE_PARTICIPANT_ACTIVE_TIME: "UPDATE_PARTICIPANT_ACTIVE_TIME",
    UPDATE_PARTICIPANT_TIMES_SINCE_LAST_CALL:
        "UPDATE_PARTICIPANT_TIMES_SINCE_LAST_CALL",
    SET_CHECKPOINT_CONVERSATION: "SET_CHECKPOINT_CONVERSATION",
    CLEAR_CHECKPOINT_CONVERSATION: "CLEAR_CHECKPOINT_CONVERSATION",
    SET_QUIZ_PROGRESS: "SET_QUIZ_PROGRESS",
    CLEAR_QUIZ_PROGRESS: "CLEAR_QUIZ_PROGRESS",
    SET_TUTOR_EVER_PRESENT: "SET_TUTOR_EVER_PRESENT",
    CLEAN_OLD_TUTOR_PRESENCE: "CLEAN_OLD_TUTOR_PRESENCE",
    ACK_TUTOR_OVERRUN: "ACK_TUTOR_OVERRUN",
    SET_LIVE_WEB_MOBILE_BANNER_SHOWN: "SET_LIVE_WEB_MOBILE_BANNER_SHOWN",
    SET_LIVE_WEB_MOBILE_BANNER_COLLAPSED:
        "SET_LIVE_WEB_MOBILE_BANNER_COLLAPSED",
    SET_LEFT_PANEL_COLLAPSED: "SET_LEFT_PANEL_COLLAPSED",
    SET_RIGHT_PANEL_COLLAPSED: "SET_RIGHT_PANEL_COLLAPSED",
    SET_FOCUS_SCREEN_SHARE: "SET_FOCUS_SCREEN_SHARE",
    BATCH_UPDATE_TIMERS: "BATCH_UPDATE_TIMERS",
    AUTO_MODE_OPEN_EVAL: "AUTO_MODE_OPEN_EVAL",
    AUTO_MODE_SET_EVAL: "AUTO_MODE_SET_EVAL",
    AUTO_MODE_ADD_PROPOSAL: "AUTO_MODE_ADD_PROPOSAL",
    AUTO_MODE_SET_LOADING: "AUTO_MODE_SET_LOADING",
    AUTO_MODE_SET_ERROR: "AUTO_MODE_SET_ERROR",
    AUTO_MODE_CLOSE: "AUTO_MODE_CLOSE",
    SET_RECENT_FINALIZED_ACTIVITY: "SET_RECENT_FINALIZED_ACTIVITY",
    CLEAR_RECENT_FINALIZED_ACTIVITY: "CLEAR_RECENT_FINALIZED_ACTIVITY",
    SET_AUTO_MODE_STARTED_ACTIVITY: "SET_AUTO_MODE_STARTED_ACTIVITY",
    CLEAR_AUTO_MODE_STARTED_ACTIVITY: "CLEAR_AUTO_MODE_STARTED_ACTIVITY",
}

export const liveKitRoomConstants = {
    SET_LIVEKIT_TOKEN: "SET_LIVEKIT_TOKEN",
    HOLD_LIVEKIT_MICROPHONE: "HOLD_LIVEKIT_MICROPHONE",
}
